import React from "react";

export const PromotionDropdownButtonImageClosed = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Image: Show promotion code field"
    >
      <path
        d="M8.92857 0H1.07143C0.479911 0 0 0.458097 0 1.02273V8.52273C0 9.08736 0.479911 9.54545 1.07143 9.54545H8.92857C9.52009 9.54545 10 9.08736 10 8.52273V1.02273C10 0.458097 9.52009 0 8.92857 0ZM8.21429 5.36932C8.21429 5.50994 8.09375 5.625 7.94643 5.625H5.89286V7.58523C5.89286 7.72585 5.77232 7.84091 5.625 7.84091H4.375C4.22768 7.84091 4.10714 7.72585 4.10714 7.58523V5.625H2.05357C1.90625 5.625 1.78571 5.50994 1.78571 5.36932V4.17614C1.78571 4.03551 1.90625 3.92045 2.05357 3.92045H4.10714V1.96023C4.10714 1.8196 4.22768 1.70455 4.375 1.70455H5.625C5.77232 1.70455 5.89286 1.8196 5.89286 1.96023V3.92045H7.94643C8.09375 3.92045 8.21429 4.03551 8.21429 4.17614V5.36932Z"
        fill="#0B75E0"
      />
    </svg>
  );
};

export const PromotionDropdownButtonImageOpen = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Image: Hide promotion code field"
    >
      <path
        d="M8.92857 0H1.07143C0.479911 0 0 0.458097 0 1.02273V8.52273C0 9.08736 0.479911 9.54545 1.07143 9.54545H8.92857C9.52009 9.54545 10 9.08736 10 8.52273V1.02273C10 0.458097 9.52009 0 8.92857 0ZM2.05357 5.625C1.90625 5.625 1.78571 5.50994 1.78571 5.36932V4.17614C1.78571 4.03551 1.90625 3.92045 2.05357 3.92045H7.94643C8.09375 3.92045 8.21429 4.03551 8.21429 4.17614V5.36932C8.21429 5.50994 8.09375 5.625 7.94643 5.625H2.05357Z"
        fill="#0B75E0"
      />
    </svg>
  );
};
